import { useEffect, useRef, useState } from "react";

const SEARCH_DELAY_MS = 300;

export function SearchBox({
  q,
  onSearch,
  ariaLabel,
  placeholder,
}: {
  q?: string;
  onSearch: (text: string) => void;
  ariaLabel: string;
  placeholder: string;
}) {
  const [text, setText] = useState(q ?? "");
  // The latest callback, so a re-render doesn't restart the pause.
  const search = useRef(onSearch);
  search.current = onSearch;
  // Back/forward changes ?q=; keep what is being typed when it already matches.
  useEffect(() => {
    setText((prev) => (prev.trim() === (q ?? "") ? prev : (q ?? "")));
  }, [q]);
  useEffect(() => {
    if (text.trim() === (q ?? "")) return;
    const timer = setTimeout(() => search.current(text.trim()), SEARCH_DELAY_MS);
    return () => clearTimeout(timer);
  }, [text, q]);
  return (
    <input
      type="search"
      aria-label={ariaLabel}
      value={text}
      onChange={(e) => setText(e.target.value)}
      placeholder={placeholder}
      className="min-w-72 flex-1 rounded-md border border-zinc-300 bg-white px-3 py-2 text-sm outline-none focus:border-brand focus:ring-1 focus:ring-brand"
    />
  );
}
